var BrowseFilter = React.createClass({
  propTypes: {
    title: React.PropTypes.string,
    filterType: React.PropTypes.string
  },
  getInitialState: () => {
    return {isDesktop: true, isAriaHidden: true};
  },
  componentDidMount() {
    this.updateState();
    window.addEventListener("resize", this.updateState);
  },
  componentDidUpdate(prevProps, prevState){
    this.checkForAriaHidden();
  },
  componentWillUnmount() {
    window.removeEventListener("resize", this.updateState);
  },
  updateState(){
    this.setState({ isDesktop: window.innerWidth > 767 });
  },
  checkForAriaHidden() {
    if(!this.state.isDesktop){
      if(this.props.isOpen){
        this.state.isAriaHidden = false;
      } else{
        this.state.isAriaHidden = true;
      }
    }
    else{ 
      this.state.isAriaHidden = false;
    }
    this.refs.filterRef.setAttribute("aria-hidden", this.state.isAriaHidden);
  },
  renderTitle() {
    return this.props.title && this.props.title.length ?
        <h4 tabIndex="0" className="filter__title">{this.props.title}</h4> :
        null;
  },
  render() {
    let filterType = this.props.filterType ? " " + this.props.filterType : "";
    let ariaLabel = this.props.ariaLabel;

    return (
      <div className={"filter" + filterType} tabIndex="0"  ref={"filterRef"} aria-label={ariaLabel ? Labels.getLabel(ariaLabel):""}>
        {this.renderTitle()}
        {this.props.children}
      </div>
    )
  }
});